
<!--<div *ngIf="isLoading()">-->
<!--    <span class="iconify text-warning" data-icon="eos-icons:loading" style="font-size: 200px"></span>-->
<!--</div>-->

<div class="loader-wrapper" *ngIf="isLoading()">
    <div class="theme-loader">
        <div class="loader-p"></div>
    </div>
</div>